import { Helmet } from "react-helmet";
import { Row, Typography } from "antd";

const { Text, Link } = Typography;

// Full-page gate shown for every route while REACT_APP_MAINTENANCE_MODE is on.
// Intentionally free of dates and of any API calls: the flag is flipped for the
// order-service migration window, during which the API is returning 503s.
const Maintenance = () => {
  return (
    <div className="p-4 text-center" data-cy="maintenance-page">
      <Helmet htmlAttributes={{ lang: "en" }}>
        <title>Biobot — Scheduled Maintenance</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <Row justify="center" className="mt-5">
        <img
          src={`${process.env.PUBLIC_URL}/assets/darkbluelogo_large.png`}
          style={{ width: "12rem", maxWidth: "80%" }}
          alt="Biobot Analytics Logo"
        />
      </Row>

      <Row justify="center" className="mt-5">
        <Text className="text-3xl">Sorry, we’ll be back online shortly!</Text>
      </Row>

      <Row justify="center" className="mt-4">
        <Text className="text-xl w-100" style={{ maxWidth: "42rem" }}>
          Biobot's portal is temporarily offline for a planned upgrade to our
          sample log system. We expect to be back within a few hours.
        </Text>
      </Row>

      <Row justify="center" className="mt-4">
        <Text className="text-xl w-100" style={{ maxWidth: "42rem" }}>
          When we return, you’ll find a new and enhanced sample log form.
        </Text>
      </Row>

      <Row justify="center" className="mt-5 mb-5">
        <Text className="text-lg">
          Questions in the meantime? Email{" "}
          <Link href="mailto:support@biobot.io">support@biobot.io</Link>.
        </Text>
      </Row>
    </div>
  );
};

export default Maintenance;
